import * as yup from 'yup';
import { toast } from 'react-toastify';
import { transformAsCurrency } from '~/utils/functions';

interface res {
  valid: boolean;
  campos: string;
}

export const schema = yup.object({
  tipo_preco_composicao: yup
    .object({
      label: yup.string().required(),
      value: yup.number().required(),
    })
    .required(),
});

export function validaParaAdd(
  data: any,
  form: any,
  itens: any[],
  tipo: number,
): res {
  let resp: res = { valid: true, campos: '' };
  if (data.cod_produto === '') {
    toast.warn('Selecione pelo menos um produto');
    resp = { valid: false, campos: 'cod_produto' };
    return resp;
  }

  if (
    !data.cod_produto.flg_ipv &&
    !Number.isInteger(Number(data.qtd_composicao))
  ) {
    resp = { valid: false, campos: 'qtd_composicao' };
    toast.warn(
      `O produto ${data.cod_produto.des_produto} não é pesável, não permitido valor fracionado.`,
    );
    return resp;
  }

  if (data.cod_produto.value === form.cod_produto.value) {
    toast.warn(
      'Produto a ser incluído é o mesmo da composição. Pesquise outro.',
    );
    resp = { valid: false, campos: 'cod_produto' };
    return resp;
  }

  if (itens.some((item: any) => item.cod_produto === data.cod_produto.value)) {
    toast.warn(
      'Produto a ser incluído é o mesmo da composição. Pesquise outro.',
    );
    resp = { valid: false, campos: 'cod_produto' };
    return resp;
  }

  if (
    data.cod_produto.flg_ipv &&
    transformAsCurrency(data.qtd_composicao) < 0.001
  ) {
    toast.warn('Quantidade não pode ser zerada.');
    resp = { valid: false, campos: 'qtd_composicao' };
    return resp;
  }

  if (
    !data.cod_produto.flg_ipv &&
    transformAsCurrency(data.qtd_composicao) < 1
  ) {
    toast.warn('Quantidade não pode ser zerada.');
    resp = { valid: false, campos: 'qtd_composicao' };
    return resp;
  }

  if (transformAsCurrency(data.val_venda_composicao) <= 0) {
    toast.warn(
      'O produto esta com o valor da venda zerado, ajuste o mesmo nas telas de Alteração de Preço',
    );
    resp = { valid: false, campos: 'val_venda_composicao' };
    return resp;
  }

  return resp;
}
